<template>
  <div class="analysis-report-filter">
    <ElForm label-width="60" inline class="elementui-common-form-styles" v-highlight>
      <ElFormItem>
        <ElInput v-model="queryForm.keyword" clearable placeholder="请输入关键词" style="width: 220px" @keyup.enter.native="sendEvent">
          <ElSelect v-model="queryForm.searchType" slot="prepend" style="width: 64px">
            <ElOption :value="1" label="素材"></ElOption>
            <ElOption :value="2" label="计划"></ElOption>
          </ElSelect>
        </ElInput>
      </ElFormItem>

      <ElFormItem label="素材游戏组">
        <el-select v-model="queryForm.gameGroupIds" style="width: 180px" multiple collapse-tags filterable clearable placeholder="全部">
          <el-option v-for="item in gameGroups" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="数据游戏组">
        <el-select v-model="queryForm.dataGroupIds" style="width: 180px" multiple collapse-tags filterable clearable placeholder="全部">
          <el-option v-for="item in gameGroups" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="设计者">
        <ThrottleSelector
          style="width: 180px"
          v-model="queryForm.designerIds"
          multiple
          collapse-tags
          :list="sysUsers"
          placeholder="全部"
          filterable
          clearable
        />
      </ElFormItem>
      <ElFormItem label="策划者">
        <ThrottleSelector
          style="width: 180px"
          v-model="queryForm.plannerIds"
          multiple
          collapse-tags
          :list="sysUsers"
          placeholder="全部"
          filterable
          clearable
        />
      </ElFormItem>

      <ElFormItem label="媒体" label-width="40px">
        <el-select v-model="queryForm.mediaIds" filterable clearable multiple collapse-tags placeholder="全部" style="width: 180px">
          <el-option v-for="item in mediaList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="计划账号" label-width="70px">
        <ThrottleSelector
          style="width: 180px"
          v-model="queryForm.adAccountIdList"
          multiple
          collapse-tags
          :list="mediaAccounts"
          placeholder="全部"
          filterable
          clearable
        />
      </ElFormItem>

      <ElFormItem label="素材类型" label-width="70px">
        <ElSelect v-model="queryForm.imgTypes" multiple collapse-tags style="width: 150px" clearable>
          <ElOption v-for="item in imageTypes" :key="item.id" :label="item.name" :value="item.id"></ElOption>
        </ElSelect>
      </ElFormItem>

      <ElFormItem label="内容标签" label-width="70px">
        <ThrottleSelector
          style="width: 190px"
          v-model="queryForm.labelId"
          multiple
          collapse-tags
          :list="labelList.contentLabels"
          placeholder="全部"
          filterable
          clearable
        />
      </ElFormItem>
      <ElFormItem label="素材样式">
        <el-cascader
          v-model="queryForm.imageStyles"
          clearable
          filterable
          collapse-tags
          style="width: 180px"
          :props="{ label: 'content', value: 'labelId', multiple: true }"
          :options="imageStyleTagTree"
        >
        </el-cascader>
      </ElFormItem>
      <ElFormItem label="素材板式">
        <ElSelect v-model="queryForm.imageOrientations" multiple collapse-tags style="width: 140px" clearable>
          <ElOption
            v-for="item in [
              { id: 1, name: '横版' },
              { id: 2, name: '竖版' },
              { id: 3, name: '方形' }
            ]"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></ElOption>
        </ElSelect>
      </ElFormItem>

      <ElFormItem label="尺寸">
        <ElSelect v-model="queryForm.imageSizeConditions" filterable multiple collapse-tags style="width: 160px" clearable>
          <ElOption v-for="item in dimension_data" :key="item.key" :label="item.label" :value="item.key"></ElOption>
        </ElSelect>
      </ElFormItem>

      <ElFormItem label="计划投放人">
        <ThrottleSelector
          style="width: 180px"
          v-model="queryForm.launchOpIdList"
          multiple
          collapse-tags
          :list="sysUsers"
          placeholder="全部"
          filterable
          clearable
        />
      </ElFormItem>

      <ElFormItem label="数据平台">
        <el-select v-model="queryForm.platforms" collapse-tags multiple clearable placeholder="全部" style="width: 150px">
          <el-option v-for="item in platformData2" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="AI标签">
        <el-cascader
          ref="aiLabelCascaderRef"
          clearable
          filterable
          v-model="queryForm.aiLabelIds"
          collapse-tags
          placeholder="请选择AI标签"
          style="width: 180px"
          :props="{ label: 'content', value: 'labelId', multiple: true }"
          :options="aiTagTree"
        >
        </el-cascader>
      </ElFormItem>

      <ElFormItem label="3D视频源" label-width="65">
        <ThrottleSelector
          style="width: 180px"
          v-model="queryForm.videoLabelId"
          multiple
          collapse-tags
          :list="labelList.threeDLabels"
          placeholder="全部"
          filterable
          clearable
        />
      </ElFormItem>

      <ElFormItem label="素材游戏">
        <ThrottleSelector
          style="width: 180px"
          v-model="queryForm.gameIds"
          multiple
          collapse-tags
          :list="games"
          placeholder="全部"
          filterable
          clearable
        />
      </ElFormItem>
      <ElFormItem label="数据游戏">
        <ThrottleSelector
          style="width: 180px"
          v-model="queryForm.dataGameIds"
          multiple
          collapse-tags
          :list="games"
          placeholder="全部"
          filterable
          clearable
        />
      </ElFormItem>

      <ElFormItem label="消耗起始时间" label-width="92px">
        <DateRangePicker v-model="queryForm.lauchTime" style="width: 220px"></DateRangePicker>
      </ElFormItem>

      <ElFormItem label="素材上传时间" label-width="92px">
        <DateRangePicker v-model="queryForm.uploadtime" style="width: 220px"></DateRangePicker>
      </ElFormItem>

      <ElFormItem label-width="0" class="bg-transparent">
        <slot></slot>
        <div class="compare-filter-trigger">
          <ElButton @click="compareFilterModalVisible = true">更多筛选</ElButton>
          <el-tooltip effect="dark" :disabled="compareFilterPreview.length === 0" placement="bottom">
            <div slot="content">
              <p v-for="text in compareFilterPreview" :key="text" style="line-height: 18px">{{ text }}</p>
            </div>
            <el-badge :hidden="compareFilterPreview.length === 0" :value="compareFilterPreview.length">&ensp;</el-badge>
          </el-tooltip>
        </div>
      </ElFormItem>
    </ElForm>

    <AnalysisReportCompareFilter v-model="compareFilter" :visible.sync="compareFilterModalVisible" @confirm="sendEvent" />
  </div>
</template>
<script setup>
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router/composables'
import DateRangePicker from '@/components/date-range-picker'
import ThrottleSelector from '@/components/throttle-select/index.vue'
import AnalysisReportCompareFilter from './analysis-report-compare-filter.vue'
import { COMPARE_OPERATOR_OPTIONS, imageTypesWithGroup as imageTypes, useFilter } from '../hooks/useFilter'
import { transferTaskQueryConditions } from '@/views/download-center/data/utils.js'
import { platformData2 } from '../../data/platformData'
import dimension_data from '@/views/material/data/dimension_data'
import { LABEL_TYPES } from '@/views/material/tags/const'
import {
  initPageData,
  MEDIA_ACCOUNTS,
  GAME_GROUPS,
  GAMES,
  MEDIAS,
  SYS_USERS,
  SYS_TAGS,
  IMAGE_STYLE_TAG_TREE,
  AI_TAG_TREE
} from '@/data/global-opts'
const route = useRoute()

// eslint-disable-next-line
const emit = defineEmits(['change'])

const PAGE_REQUIRED_OPTS = initPageData([
  GAME_GROUPS,
  MEDIA_ACCOUNTS,
  SYS_USERS,
  GAMES,
  MEDIAS,
  IMAGE_STYLE_TAG_TREE,
  AI_TAG_TREE,
  SYS_TAGS
])
const gameGroups = computed(PAGE_REQUIRED_OPTS.GAME_GROUPS)
const mediaAccounts = computed(PAGE_REQUIRED_OPTS.MEDIA_ACCOUNTS)
const sysUsers = computed(PAGE_REQUIRED_OPTS.SYS_USERS)
const games = computed(PAGE_REQUIRED_OPTS.GAMES)
const mediaList = computed(PAGE_REQUIRED_OPTS.MEDIAS)
const sysTags = computed(PAGE_REQUIRED_OPTS.SYS_TAGS)
const imageStyleTagTree = computed(PAGE_REQUIRED_OPTS.IMAGE_STYLE_TAG_TREE)
const aiTagTree = computed(PAGE_REQUIRED_OPTS.AI_TAG_TREE)
const labelList = computed(() => {
  return {
    contentLabels: (sysTags.value || []).filter((tag) => tag.labelType === LABEL_TYPES.CONTENT_LABEL), // 内容标签
    threeDLabels: (sysTags.value || []).filter((tag) => tag.labelType === LABEL_TYPES.THREED_LABEL)
  }
})

const { queryForm, buildParams, setQueryParams, sendEvent } = useFilter(route, emit, imageStyleTagTree)
const compareFilterModalVisible = ref(false)
const compareFilter = computed({
  get: () => ({
    amountOperatorType: queryForm.value.amountOperatorType,
    amountValue: queryForm.value.amountValue,
    newRoleRateOperatorType: queryForm.value.newRoleRateOperatorType,
    newRoleRateValue: queryForm.value.newRoleRateValue
  }),
  set: (value) => Object.assign(queryForm.value, value)
})
const isEmptyCompareValue = (value) => value === undefined || value === null || value === ''
const getCompareOperatorLabel = (operatorType) => COMPARE_OPERATOR_OPTIONS.find((item) => item.value === operatorType)?.label || ''
const compareFilterPreview = computed(() => {
  const texts = []
  if (!isEmptyCompareValue(compareFilter.value.amountValue)) {
    texts.push(`实际消耗${getCompareOperatorLabel(compareFilter.value.amountOperatorType)}${compareFilter.value.amountValue}元`)
  }
  if (!isEmptyCompareValue(compareFilter.value.newRoleRateValue)) {
    texts.push(
      `新创角回款率${getCompareOperatorLabel(compareFilter.value.newRoleRateOperatorType)}${compareFilter.value.newRoleRateValue}%`
    )
  }
  return texts
})

// Expose methods to parent
// eslint-disable-next-line
defineExpose({
  queryForm,
  buildParams,
  setQueryParams,
  // Helper for export
  getTransferedTaskQueryConditions: (extraParams, pageType) => {
    // We need to mimic the original behavior where `this` context was used
    // But since we extracted `buildParams` into the hook, we can just use it directly
    // However, the utility function expects `this` to have `buildParams`
    // So we construct a fake context object
    const context = {
      gameGroups: gameGroups.value,
      mediaAccounts: mediaAccounts.value,
      sysUsers: sysUsers.value,
      sysTags: sysTags.value,
      games: games.value,
      mediaList: mediaList.value,
      imageStyles: imageStyleTagTree.value,
      imageTypes
    }
    return transferTaskQueryConditions.call(context, { ...buildParams(), ...extraParams }, pageType)
  }
})
</script>

<style lang="scss" scoped>
.compare-filter-trigger {
  display: inline-flex;
  align-items: center;
  margin-left: 10px;
}
</style>
